module.exports = __webpack_public_path__ + "img/bg_top.1775439203884.png";